import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'recompose';

import { defaultProducts, products, query, totalItems } from 'ggApp/modules/search/selectors';

import ExpandedContent from './ExpandedContent';

const enhance = compose(
    connect(
        createStructuredSelector({
            trendingProducts: defaultProducts,
            searchProducts: products,
            searchQuery: query,
            totalItems,
        }),
    ),
);

export default enhance(ExpandedContent);
